export const CURRENCY_THRESHOLD = 99999;
